// import React, { Component } from 'react';
// import './donate.css';

// class Donate extends Component {
// 	constructor(props) {
// 		super(props);
// 		this.state = {
// 			donate : []            
// 		};
// 	  }
	
// 	componentDidMount() {
// 		this.getDonate();
// 	  }
	
// 	  // Retrieves the list of items from the Express app
// 	  getDonate = () => {
// 		fetch('/api/donate')
// 		.then(res => res.json())
// 		.then(donate => this.setState({ donate }));

// 	  }

// 	render() {
// 		const { donate } = this.state;
		
// 		return (
// 			<React.Fragment>
// 				<h1>{donate.headline}</h1>
// 				{donate.length ? (
// 					<div className="mapContent donateContainer fullStage relative" >
// 						{/* Render the list of items */}
// 						{donate.map((donate, i) => {
// 						return(
// 							<React.Fragment key={i}>
								
// 							<div className="donateBlock dontateInfoBlock floatLeft wT tfStage">
// 								<div className="donateInfo marginBotSmall" dangerouslySetInnerHTML={{ __html : donate.orgInfo }}></div>
// 								<div className="donorBoxHold" dangerouslySetInnerHTML={{ __html : donate.tempCode }}></div>

// 							</div>
// 							<div className="donateBlock floatLeft donateCopyBlock wT clearBoth" dangerouslySetInnerHTML={{ __html : donate.donateCopy }}></div>
								
								
// 							</React.Fragment>
// 						);
// 						})}
// 					</div>
// 					) : (
// 						<div className="fullWidth fullHeight redT blinkFast loader">
// 						<div className="centeredContent">•</div>
// 					</div>
					
// 					)
// 				}
// 			</React.Fragment>
// 		)
// 	}
//   }
  
//   export default Donate;

import React, { Component } from 'react'
import { Link, Route } from 'react-router-dom'
import ProjectList from './projects'
import Message from './message'
import './donate.css'

// const survival = {
// 	name: "ANNUAL MINIMUM (SURVIVAL)",
// 	goal: 60000,
// 	current: 35501,
// 	donations: 2254,
// 	description: 'The daily operations of BSA consist of phone calls, emails, social media maintenance, travel, meetings, and more. As of now, we only have one full-time staffer. We also have annual legal and accounting fees. Though this figure is less than ideal, we need at least $60,000 annually in order to survive as an organization (you can think of this as a "life support" figure).',
// 	link: "https://donorbox.org/embed/annual-minumum"
// };


class Donate extends Component {
	constructor(props) {
		super(props);
		this.state = {
			donate : [],
			survival:null
		};
	}
		
	componentDidMount() {
		this.getDonate();
	}
		
	// Retrieves the list of items from the Express app
	getDonate = () => {
		fetch('/api/donate')
		.then(res => res.json())
		.then(donate => {
			this.setState({ donate },()=>{
				if(this.state.donate.length){
					if(this.state.donate[0].options.length){
						this.setState({survival:this.state.donate[0].options[0]})
					}
				}
			})
		});
	}

	openIframe = (project) => {
		console.log(project);
		const selector = project.title.split(" ")[1];
		const allIframes = document.getElementsByClassName("iframe");
		const iframeArray = Object.values(allIframes);
		iframeArray.map((iframe) => {
			iframe.height = "120"
		});

		const iframe = document.getElementsByClassName(selector + "-iframe")[0];
		if (iframe) iframe.height = "840";

		iframe.scrollIntoView({behavior: "smooth"});
		if (selector === "STAFF") {
			document.getElementById("DonateVia").classList.add("visible");
		}
	}

	scrollToProjects = () => {
		const projectsUL = document.getElementsByClassName("project-list")[0];
		projectsUL.scrollIntoView({behavior: "smooth"});
	}

	render() {
		const { donate, survival } = this.state;

		return (
			<React.Fragment>
				{donate.length && survival? (
					<div className="mapContent donateContainer" >
						<Route exact path="/donate" render={()=><Message manualMap={this.props.manualMap}/>} />
						<div className="imperative" dangerouslySetInnerHTML={{ __html : donate[0].orgInfo }}></div>

						<div className="survival">
							<div className="project-text-head">
								<h2 className="project-title">{survival.title}</h2>
								<div className="buttonCTA buttonText wT" onClick={this.openIframe.bind(this, survival)}>
									<p>DONATE</p>
								</div>
							</div>
							<div className="project-donorbox">
								<iframe className={survival.title.split(" ")[1] + "-iframe"} src={survival.opt1} height="145px" width="100%" seamless="seamless" name="donorbox" frameBorder="0" scrolling="no" allowpaymentrequest="true"></iframe>
								<div id="DonateVia">
									<p>or donate via</p>
									<div className="buttons">
										<a id="DonateCrypto" href="https://commerce.coinbase.com/checkout/9d0e0e90-a900-4799-aa1f-53069ccdb613" alt="Donate with crytocurrency via Coinbase">
											<img src="images/coinbase.png" alt="Coinbase logo"/>
											<p>Coinbase</p>
										</a>
										<a id="DonateCashApp" href="https://cash.app/$BlackSocialists" alt="Donate via CashApp">
											<img src="images/cashapp.png" alt="CashApp logo"/>
											<p>Cash App</p>
										</a>
									</div>
								</div>
							</div>
							<div className="project-description"  dangerouslySetInnerHTML={{ __html : survival.opt2}}></div>
						</div>

						<div className="donateBottom">
							<Route exact path="/donate" render={()=><ProjectList donors={donate[0].options}/>} />
							<div className="holdUp" dangerouslySetInnerHTML={{ __html : donate[0].donateCopy }}></div>
						</div>
					</div>
				) : (
					<div className="fullWidth fullHeight redT blinkFast loader">
						<div className="centeredContent">•</div>
					</div>
				)}
			</React.Fragment>
		)
	}
}

export default Donate;



// WEBPACK FOOTER //
// ./src/components/donate/donate.js